import { Divider, Stack, Typography } from "@mui/material";
import {
  COMMISSION_PERCENT,
  estimateProceeds,
  formatUsd,
  parsePriceCents,
} from "./pricing";

export default function EarningsEstimate({ price }: { price: string }) {
  const cents = parsePriceCents(price);
  const estimate = cents === null ? null : estimateProceeds(cents);
  return (
    <Stack spacing={2}>
      <Typography
        component="h3"
        variant="h6"
        fontWeight={750}
        color="secondary.main"
      >
        What You'll Earn
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Estimated per toy, at your asking price.
      </Typography>
      <Stack direction="row" justifyContent="space-between" gap={2}>
        <Typography>Toy price</Typography>
        <Typography>{cents === null ? "—" : formatUsd(cents)}</Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" gap={2}>
        <Typography>FiddlePiddle fee ({COMMISSION_PERCENT}%)</Typography>
        <Typography sx={{ whiteSpace: "nowrap" }}>
          {estimate ? `−${formatUsd(estimate.commissionCents)}` : "—"}
        </Typography>
      </Stack>
      <Divider />
      <Stack direction="row" justifyContent="space-between" gap={2}>
        <Typography fontWeight={700}>Estimated earnings</Typography>
        <Typography fontWeight={750} color="secondary.main">
          {estimate ? formatUsd(estimate.proceedsCents) : "—"}
        </Typography>
      </Stack>
      <Typography variant="caption" color="text.secondary">
        Excludes other potential costs, including shipping, taxes, and any
        applicable payment charges. Final payouts may differ.
      </Typography>
    </Stack>
  );
}
